import { css } from '@emotion/core';
import { screenSmall } from '../../../styles/theme/breakpoints';

export const modalForm = css`
  @media screen and (min-width: ${screenSmall}) {
    height: 95%;
    max-height: 680px;
    max-width: 438px;
  }
`;

export default modalForm;
